import React from "react";
import { useTranslation } from "react-i18next";
import {
  ScreeningDto,
  TelecommunicationDtoMethodEnum,
} from "@docket/consumer-app-client-typescript-axios";
import { getDateTime } from "../utils/data";

interface EventCardProps {
  screeningEvent: ScreeningDto;
}

const lead = "/assets/images/Icons_Screening_Lead.png";

export default function ScreeningEventCard({ screeningEvent }: EventCardProps) {
  const { t } = useTranslation();

  const readableDate = (date: string) => {
    return getDateTime(date).toLocaleString();
  };

  const hasOrderingFacilityData =
    screeningEvent.orderingFacility &&
    (screeningEvent.orderingFacility.names.length > 0 ||
      screeningEvent.orderingFacility.contactInfo.length > 0);

  return (
    <div className="card bg-base-100 max-md:mx-4">
      <img className="w-12 absolute right-4 top-4" src={lead} alt={`Lead Image`} />
      <div className="card-body">
        {screeningEvent.testDate && (
          <div role="paragraph" className="card-title" data-testid="event-card-title">
            {readableDate(screeningEvent.testDate)}
          </div>
        )}
        <div className="grid grid-cols-[auto_1fr]">
          {screeningEvent.type && (
            <>
              <span className="text-primary mr-2">{t("screening.records_event_specimen")}</span>
              <span className="font-semibold">
                {t("screening.results_lead", { context: screeningEvent.type })}
              </span>
            </>
          )}
          {screeningEvent.measurement && (
            <>
              <span className="text-primary mr-2">{t("screening.records_event_test_value")}</span>
              <span className="font-semibold">
                {screeningEvent.measurement + " "}
                {screeningEvent.units ? screeningEvent.units : ""}
              </span>
            </>
          )}
          {screeningEvent.laboratory && (
            <>
              <span className="text-primary mr-2">{t("screening.records_event_laboratory")}</span>
              <span className="font-semibold">{screeningEvent.laboratory}</span>
            </>
          )}
          {hasOrderingFacilityData && (
            <>
              <span className="text-primary mr-2">
                {t("screening.records_event_ordering_facility")}
              </span>
              <span className="font-semibold">
                {screeningEvent.orderingFacility.names.join(", ")}
              </span>
              {screeningEvent.orderingFacility.contactInfo.map((contact, index) => (
                <React.Fragment key={index}>
                  {contact.method !== TelecommunicationDtoMethodEnum.Unknown && (
                    <>
                      <span className="text-primary mr-2">
                        {t(`screening.records_event_contact`, {
                          context: contact.method.toLowerCase(),
                        })}
                      </span>
                      <span className="font-semibold break-all">{contact.value}</span>
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
        </div>
      </div>{" "}
    </div>
  );
}
